import React, { ComponentType, Fragment } from "react";
import Row from "../../../../../components/Common/Row";
import Col from "../../../../../components/Common/Col";
import { formatCurrency } from "../../../../../utils/Format";
import {
  hfInformationCost,
  informationCost,
  informationCostDiscount,
  standardInformationCost
} from "../../../../../utils/Cost";
import { OrderCostSummaryV2Props } from "../index";
import OrderPolicy from "../../../../../policies/OrderPolicy";
import { selectUser } from "../../../../../store/selectors/UserSelectors";
import { useSelector } from "react-redux";

interface Props extends OrderCostSummaryV2Props {
  component?: ComponentType<{ label: string, value: string }>;
}

const Item = (props: { label: string, value: string }) => {
  const { label, value } = props;
  return (
    <Row>
      <Col sm={12} md={10}>
        {label}
      </Col>
      <Col sm={12} md={2}>
        {value}
      </Col>
    </Row>
  )
}

const InformationCostVariant = (props: Props) => {
  const { cost, orderCategory, component } = props;
  const user = useSelector(selectUser);

  const Component = component ? component : Item;

  if (!OrderPolicy.canViewInformationCostBreakdown(user, orderCategory)) {
    return <Component label="Annual Information Cost" value={formatCurrency(informationCost(cost))} />;
  }

  return (
    <Fragment>
      <Component label="Annual Standard Information Cost" value={formatCurrency(standardInformationCost(cost))} />
      <Component label="Annual High Frequency Information Cost" value={formatCurrency(hfInformationCost(cost))} />
    </Fragment>
  )
}

const InformationCost = (props: Props) => {
  const { cost, component } = props;
  const { total_cost } = cost.data;

  if (!total_cost) {
    return null;
  }

  const isDiscounted = total_cost.information_cost !== total_cost.information_cost_after_discount;
  const Component = component ? component : Item;

  return (
    <Fragment>
      <InformationCostVariant {...props} />

      {
        isDiscounted &&
        <Component label="Applicable discount" value={formatCurrency(informationCostDiscount(cost))} />
      }
    </Fragment>
  )
}

export default InformationCost;
